export function formatAED(value) {
  if (value == null || value === "") return "—";
  const n = Number(value);
  if (Number.isNaN(n)) return "—";
  if (n >= 1_000_000) return `AED ${(n / 1_000_000).toFixed(n % 1_000_000 === 0 ? 0 : 1)}M`;
  if (n >= 1_000) return `AED ${(n / 1_000).toFixed(0)}K`;
  return `AED ${n}`;
}

export function formatRange(min, max) {
  if (!min && !max) return "—";
  if (min && max) return `${formatAED(min)} – ${formatAED(max)}`;
  return formatAED(min || max);
}

export function initialsOf(name = "") {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export function relativeTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return d.toLocaleDateString(undefined, { day: "numeric", month: "short" });
}

export function formatDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

export function formatFileSize(bytes) {
  if (!bytes && bytes !== 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString(undefined, {
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function countdown(iso) {
  if (!iso) return "—";
  const ms = new Date(iso).getTime() - Date.now();
  if (ms < 0) return "Past";
  const d = Math.floor(ms / 86400000);
  const h = Math.floor((ms % 86400000) / 3600000);
  const time = new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  if (d === 0 && h < 2) {
    const m = Math.floor((ms % 3600000) / 60000);
    return `In ${h}h ${m}m`;
  }
  if (d === 0) return `Today at ${time}`;
  if (d === 1) return `Tomorrow at ${time}`;
  if (d <= 7) return `In ${d} days`;
  return new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short" });
}

export const STATUS_LABELS = {
  open: "Open",
  in_discussion: "In Discussion",
  proposal_sent: "Proposal Sent",
  won: "Won",
  lost: "Lost",
  on_hold: "On Hold",
};

export const KANBAN_COLUMNS = [
  { key: "open", label: "Open" },
  { key: "in_discussion", label: "In Discussion" },
  { key: "proposal_sent", label: "Proposal Sent" },
  { key: "won", label: "Won" },
  { key: "lost", label: "Lost" },
];

export const SECTOR_COLORS = {
  "Real Estate": "#C9A84C",
  "Legal & Corporate": "#B58B3F",
  "Finance & Investment": "#D4B45A",
  "Marketing & Brand": "#9A7E36",
  "Technology & Digital": "#E1C97A",
  Operations: "#7C6628",
};
